/* eslint-disable prefer-const */
// Write the id back to formData object, which will be used to populate the form
export default function updateFormData(formData, note) {
  const data = formData.property?.data || formData.abonly?.data || formData.auto?.data;
  // policy holder
  formData.container.policyHolder.id = note[formData.container.policyHolder.policySystemId];
  // reporter && reporter note
  if (formData.container.reporter && Object.keys(formData.container.reporter).length > 0) {
    formData.container.reporter.id = note[formData.container.reporter.temporaryId];
    formData.container.reporter.noteId = note[formData.container.reporter.noteTemporaryId];
  }
  // additional details note
  data.additionalDetailsNoteId = note[data.additionalDetailsNoteTemporaryId];
  // abonly driver note
  if (data?.abDriver?.peopleInTheOtherVehiclesInfo?.[0]) {
    data.abDriver.peopleInTheOtherVehiclesInfo[0].noteId = note[data.abDriver.peopleInTheOtherVehiclesInfo[0].noteTemporaryId];
  }

  if (formData.abonly?.data?.lossCause?.value === 'occupantThirdPartyVehicle') {
    // abonly - occupant of third party vehicle - vehicle incident driver
    data.vehicleId = note[data.vehiclePolicySystemId];
  }
  // auto reverse mapping
  if (!formData.property) {
    formData.container.policyHolder.vehicleIncidentId = note[formData.container.policyHolder.vehicleIncidentTempId];
    formData.claim_type.vehicle.id = note[formData.claim_type.vehicle.policySystemId];

    // driver
    if (data.driver && Object.keys(data.driver).length > 0) {
      data.driver.id = note[data.driver.temporaryId];
    }
    // third party contacts
    data.thirdParty?.peopleInTheOtherVehiclesInfo?.forEach((tp) => {
      tp.id = note[tp.temporaryId];
      tp.vehicleIncidentId = note[tp.vehicleIncidentTempId]; // third party vehicle incident
      tp.injuryIncidentId = note[tp.injuryIncidentTemporaryId]; // third party injury incident
    });
    // whoDrivingVehicle
    if (data.whoDrivingVehicle) {
      const temp = data.whoDrivingVehicle.value.policySystemId || data.whoDrivingVehicle.value.temporaryId;
      data.whoDrivingVehicle.value.id = note[temp];
    }
    // passengers
    if (data.passengers?.addPassengerInfo) {
      data.passengers.addPassengerInfo.forEach((passenger) => {
        const temp = passenger.policySystemId || passenger.temporaryId;
        passenger.id = note[temp];
      });
    }
    // injury incident
    if (data.injuredInjuries?.whatAreTheInjuriesInfo) {
      data.injuredInjuries.whatAreTheInjuriesInfo.forEach((injury) => {
        injury.id = note[injury.temporaryId];
        const temp = injury.injuredPolicySystemId || injury.injuredTemporaryId;
        injury.injuredId = note[temp];
      });
    }
    // tow company
    if (data.towProvider?.temporaryId) {
      data.towProvider.id = note[data.towProvider.temporaryId];
    }
  } else { // property reverse mapping
    data.dwellingIncidentId = note[data.dwellingIncidentTemporaryId];
    data.propertyContentsIncidentId = note[data.propertyContentsIncidentTemporaryId];
    data.otherStructureIncidentId = note[data.otherStructureIncidentTemporaryId];
    if (data.assistCleaningDamages?.temporaryId) {
      data.assistCleaningDamages.id = note[data.assistCleaningDamages.temporaryId];
    }
    if (formData.condo && Object.keys(formData.condo).length > 0) {
      formData.condo.id = note[formData.condo.temporaryId];
      formData.condo.noteId = note[formData.condo.noteTemporaryId];
    }
  }
}
